// extracted by mini-css-extract-plugin
module.exports = {"root":"PendingPaymentAlert_root__3qw5h","buttons":"PendingPaymentAlert_buttons__3ZmEg"};